import {
  TypedDocumentNode,
  useQuery,
  ApolloClient,
  QueryHookOptions,
  gql,
} from '@apollo/client'

import { getCacheableContext } from '@emico/apollo'
import { UrlRewriteEntityTypeEnum } from '@emico/graphql-schema-types'

import {
  ResolveUrlQuery,
  ResolveUrlQueryVariables,
} from './resolveUrl.query.generated'

const query = gql`
  query ResolveUrl($url: String!) {
    urlResolver(url: $url) {
      id
      type
      relativeUrl
      redirectCode
      prismicType
      authRequired
      product {
        id
        __typename
      }
    }
  }
` as TypedDocumentNode<ResolveUrlQuery, ResolveUrlQueryVariables>

export default query

export function useResolveUrl(
  urlKey: string,
  options: Omit<
    QueryHookOptions<ResolveUrlQuery, ResolveUrlQueryVariables>,
    'variables'
  > = {},
) {
  const { data, ...others } = useQuery(query, {
    ...options,
    variables: {
      url: urlKey,
    },
    context: getCacheableContext(),
  })

  return {
    data: data?.urlResolver,
    ...others,
  }
}

export const resolveUrl = (client: ApolloClient<unknown>) => async (
  url: string,
) =>
  client.query({
    query,
    variables: {
      url,
    },
    context: getCacheableContext(),
  })

export async function storeResolvedUrl(
  client: ApolloClient<unknown>,
  url: string,
  type: UrlRewriteEntityTypeEnum,
  redirectCode: number,
  prismicType?: string,
  authRequired?: boolean,
  id?: number,
  productTypeName?: string,
  productId?: number
) {
  client.writeQuery({
    query,
    variables: {
      url,
    },
    data: {
      urlResolver: {
        type,
        id: id ?? null,
        relativeUrl: url.substr(1),
        redirectCode,
        __typename: 'EntityUrl',
        prismicType: prismicType ?? null,
        authRequired: authRequired ?? false,
        product: productTypeName && productId ? {
          id: productId,
          __typename: productTypeName
        } : null
      },
    },
  })
}
